import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { statementsRoutes } from './routes';
export class Statement {
  constructor() {
    _defineProperty(this, "routes", statementsRoutes);
  }
  async getAccountStatement(data, options) {
    const resp = await requestService('payment').get(this.routes.accountStatement, _objectSpread({
      params: {
        year: data.year,
        month: data.month + 1,
        accountId: data.accountId
      }
    }, options.cancelToken));
    return resp.data;
  }
  async getAccountStatementsPreview(data, options) {
    const resp = await requestService('payment').get(this.routes.accountStatementsPreview, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: {
        accountId: data.accountId
      }
    }));
    return resp.data;
  }
  async getPropertyStatements(data, options) {
    const resp = await requestService('payment').get(this.routes.propertyStatements, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async sendPaperStatement(data, options) {
    const resp = await requestService('payment').post(this.routes.sendPaperStatement, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async statement(statementId, options) {
    const resp = await requestService('payment').get(this.routes.statement(statementId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async voidStatement(data, options) {
    const resp = await requestService('payment').post(this.routes.voidStatement, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}